import { useRequiredContext } from "@redotech/react-util/context";
import { useTriggerLoad } from "@redotech/react-util/load";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useEffect, useMemo, useState } from "react";
import { RedoAdminRpcClientContext } from "../../../app/redo-admin-rpc-client-provider";
import { TeamContext } from "../../team";

// TODO @joe/organizations - make this a pretty standalone table rather than a list of names
export const ConnectTeamTo3plCard = memo(function ConnectTeamTo3plCard() {
  const client = useRequiredContext(RedoAdminRpcClientContext);
  const team = useRequiredContext(TeamContext);
  const [teamToFulfillFor, setTeamToFulfillFor] = useState<string>("");

  const [fulfillsForTeamsLoad, getFulfillsForTeams] = useTriggerLoad(
    async () => {
      return await client.getFulfillForTeams({
        fulfillmentServiceTeamId: team._id,
      });
    },
  );

  useEffect(() => {
    getFulfillsForTeams();
  }, [getFulfillsForTeams]);

  const [connectTeamTo3plLoad, connectTeamTo3pl] = useTriggerLoad(async () => {
    await client.connectTeamTo3pl({
      fulfillmentServiceTeamId: team._id,
      teamToFulfillFor,
    });
    getFulfillsForTeams();
  });

  const connectedTeams = useMemo(() => {
    return fulfillsForTeamsLoad.value?.teams ?? [];
  }, [fulfillsForTeamsLoad.value]);

  return (
    <Card
      subtitle="This fulfillment service will be able to fulfill for the teams below"
      title="Add a team"
    >
      <Flex dir="row">
        <RedoTextInput
          fullWidth
          placeholder="67bdcae4433b1abda5387360"
          setValue={setTeamToFulfillFor}
          value={teamToFulfillFor}
        />
        <RedoButton
          disabled={teamToFulfillFor.length === 0}
          hierarchy="primary"
          onClick={() => {
            connectTeamTo3pl();
          }}
          pending={connectTeamTo3plLoad.pending}
          text="Add team"
          theme="success"
        />
      </Flex>
      <Flex dir="column" gap="xl" w="lg">
        <Flex dir="column" gap="none">
          {connectedTeams.map((team: { _id: string; name: string }) => (
            <Flex key={team._id}>
              <Text>{team.name}</Text>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Card>
  );
});
